/*
* @描述: 选择产品弹窗
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-01-23 10:32:02
*/
<template>
    <el-dialog :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="dialogVisible"
               custom-class="select_product_dialog"
               title="选择产品"
               width="1100px"
               @close="handleClickDialogCancel">
        <div v-loading="loading" class="select_product_wrap">
            <div class="left_category_wrap">
                <div :class="{'active':categoryId===0}" class="all_goods"
                     @click="handleClickCategoryNode({id:0,name:''})">全部
                </div>
                <div :class="{'noActiveTree':categoryId===0}" class="category_list_wrap">
                    <el-tree :current-node-key="categoryId"
                             :data="categoryList"
                             :expand-on-click-node='false'
                             :props="{children: 'children',label: 'name'}"
                             check-on-click-node
                             check-strictly
                             default-expand-all
                             highlight-current
                             node-key="id"
                             @node-click="handleClickCategoryNode">
                        <div slot-scope="{ node, data }" class="custom_tree_node">
                            <div class="node_label ellipsis">
                                <EllipsisTooltip :text="node.label"></EllipsisTooltip>
                            </div>
                        </div>
                    </el-tree>
                </div>
            </div>
            <div class="center_product_wrap">
                <div class="flex_js_wrap">
                    <el-input placeholder="请输入想搜索的内容"
                              size="small"
                              v-model="keyword"
                              class="search_input"
                              clearable
                              ref="search_input"
                              @blur="getProductList"
                              @clear="getProductList"
                              @keyup.enter.native="handleSearchInputEnter"
                              suffix-icon="el-icon-search">
                    </el-input>
                    <el-checkbox v-model="categoryChecked"
                                 v-if="categoryId"
                                 @change="handleClickSelectCategory">选择该分组
                    </el-checkbox>
                </div>
                <el-table ref="productTable"
                          :data="productList"
                          border
                          height="490px"
                          row-key="goods_id"
                          @select="handleProductTableSelectChange"
                          @select-all="handleProductTableSelectAllChange">
                    <el-table-column align="center" type="selection" width="40"></el-table-column>
                    <el-table-column label="产品名称" prop="goods_name">
                        <template slot-scope="{row}">
                            <span class="goods_name" v-text="row.goods_name"></span>
                            <el-tag v-if="row.brand_name"
                                    size="mini"
                                    type="warning"
                                    v-text="row.brand_name"></el-tag>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="pagination.pageNum"
                               :layout="pagination.layout"
                               :page-size="pagination.pageSize"
                               :page-sizes="pagination.pageSizes"
                               :total="pagination.total"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange">
                </el-pagination>
            </div>
            <div class="right_selected_wrap">
                <h4>已选</h4>
                <ul class="selected_list">
                    <li v-for="item in selectedGoodsList" :key="item.id" class="selected_item">
                        <div class="selected_name_wrap">
                            <span class="type_name" v-text="item.type==='goods'?'产品：':'分组：'"></span>
                            <span class="selected_name" v-text="item.name"></span>
                        </div>
                        <span class="handle_icon_wrap handle_icon_danger_wrap"
                              @click="handleClickDelSelectedGoods(item)">
                            <i class="iconfont icon-shanchu1"></i>
                        </span>
                    </li>
                </ul>
                <div class="handle_btn_wrap">
                    <el-button size="small" @click="handleClickDialogCancel">取消</el-button>
                    <el-button size="small" type="primary" @click="handleClickDialogConfirm">确定</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import {GoodsCategoryList, GoodsList} from "@/api";
import EllipsisTooltip from '@/components/pComponents/ellipsisTooltip';
import {pagination} from "@/mixins";

export default {
    name: "SelectProductDialog",
    data() {
        return {
            selectedGoodsList: [],
            categoryId: '',
            categoryName: '',
            categoryChecked: false,
            categoryList: [],
            productList: [],
            keyword: '',
            loading: false
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
    },
    mixins: [pagination],
    components: {
        EllipsisTooltip
    },
    created() {
        this.loading = true
        this.getCategoryList()
    },
    mounted() {
    },
    methods: {
        // 关闭弹窗
        handleClickDialogCancel() {
            this.$emit('update:dialogVisible', false)
        },

        //选择该分组
        handleClickSelectCategory(val) {
            if (val) {
                this.selectedGoodsList.push({
                    type: 'category',
                    id: this.categoryId,
                    category_id: '',
                    name: this.categoryName,
                })
            } else {
                this.selectedGoodsList.splice(this.selectedGoodsList.findIndex(item => item.id === this.categoryId && item.type === 'category'), 1)
            }
        },

        //获取产品分组
        getCategoryList(keyword) {
            GoodsCategoryList({
                keyword: keyword
            }).then(res => {
                if (res.code === 200) {
                    this.categoryList = res.data
                    this.getProductList()
                } else {
                    this.$message.error(res.message)
                    this.loading = false
                }
            })
        },

        //获取产品列表
        getProductList() {
            this.loading = true
            GoodsList({
                category_id: this.categoryId,
                keyword: this.keyword,
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
            }).then(res => {
                if (res.code === 200) {
                    const {list, total} = res.data
                    this.pagination.total = total
                    this.productList = list
                    if (this.selectedGoodsList.length) {
                        this.selectedGoodsList.forEach(item => {
                            const row = this.productList.find(goods => goods.goods_id === item.id && item.type === 'goods')
                            if (row) {
                                this.$nextTick(() => {
                                    this.$refs.productTable.toggleRowSelection(row, true);
                                })
                            }
                        })
                    }
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            })
        },

        handleSearchInputEnter() {
            this.$refs.search_input.blur()
        },

        //点击分类
        handleClickCategoryNode(data) {
            this.categoryId = data.id
            this.categoryName = data.name
            this.pagination.pageNum = 1
            this.getProductList()
            if (this.categoryId) {
                this.categoryChecked = this.selectedGoodsList.findIndex(item => item.id === data.id && item.type === 'category') > -1
            }
        },

        //产品列表选择事件
        handleProductTableSelectChange(selection, row) {
            const index = selection.findIndex(item => item.goods_id === row.goods_id)
            if (index > -1) {
                this.selectedGoodsList.push({
                    type: 'goods',
                    id: row.goods_id,
                    category_id: row.category_id,
                    name: row.goods_name,
                })
            } else {
                this.selectedGoodsList.splice(index, 1)
            }
        },

        //产品列表全选事件
        handleProductTableSelectAllChange(selection) {
            if (selection.length > 0) {
                selection.forEach(goods => {
                    if (this.selectedGoodsList.findIndex(item => item.type === 'goods' && item.id === goods.goods_id) === -1) {
                        this.selectedGoodsList.push({
                            type: 'goods',
                            id: goods.goods_id,
                            category_id: goods.category_id,
                            name: goods.goods_name,
                        })
                    }
                })
            } else {
                const stockIds = this.productList.map(item => item.goods_id);
                this.selectedGoodsList = this.selectedGoodsList.filter(item => {
                    return !(item.type === 'goods' && stockIds.includes(item.id));
                });
            }
        },

        //已选删除
        handleClickDelSelectedGoods(goods) {
            this.selectedGoodsList.splice(this.selectedGoodsList.findIndex(item => item.type === goods.type && item.id === goods.id), 1)
            if (goods.type === 'goods') {
                const productTable = this.$refs.productTable;
                const row = productTable.data.find(row => row.goods_id === goods.id);
                if (row) {
                    productTable.toggleRowSelection(row, false);
                }
            }
            this.categoryChecked = this.selectedGoodsList.findIndex(item => item.type === 'category' && item.id === goods.category_id) > -1
        },

        handleSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val
            this.getProductList()
        },

        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getProductList()
        },

        //选择确定事件
        handleClickDialogConfirm() {
            this.$emit('confirm', this.selectedGoodsList)
            this.$emit('update:dialogVisible', false)
        },
    },
}
</script>
<style lang="scss">
.select_product_dialog {
    .el-dialog__body {
        padding: 0;

        .select_product_wrap {
            width: 100%;
            height: 614px;
            background-color: #F7F8FA;
            display: flex;
            gap: 4px;

            .left_category_wrap {
                width: 220px;
                background-color: #FFFFFF;
                padding: 12px;
                border-radius: 6px;

                .all_goods {
                    height: 38px;
                    line-height: 38px;
                    border-radius: 6px;
                    padding: 0 16px;
                    cursor: pointer;

                    &:hover {
                        background-color: rgba(0, 0, 0, 0.04);
                    }

                    &.active {
                        background-color: rgba(41, 144, 255, 0.16);
                        color: #2990ff;
                        font-weight: 700;
                    }
                }

                h4 {
                    padding: 8px;
                    line-height: 22px;
                    font-size: 14px;
                    color: #333333;
                }

                .category_list_wrap {
                    width: 100%;
                    height: calc(100% - 46px);
                    overflow-y: auto;
                    margin-top: 8px;
                    overflow-x: hidden;

                    &.noActiveTree {
                        .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
                            background-color: #FFFFFF;
                            color: #666666;
                            font-weight: 400;
                            border-radius: 6px;
                        }
                    }

                    .custom_tree_node {
                        padding-right: 8px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;

                        .node_label {
                            width: calc(100% - 10px);
                            font-size: 14px;
                        }
                    }
                }

                .el-tree-node__content {
                    height: 38px;

                    &:hover {
                        background-color: rgba(0, 0, 0, 0.04);
                    }
                }

                .el-tree-node__expand-icon {
                    color: #333333;

                    &.is-leaf {
                        color: transparent !important;
                    }
                }

                .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
                    background-color: rgba(41, 144, 255, 0.16);
                    color: #2990ff;
                    font-weight: 700;
                    border-radius: 6px;
                }
            }

            .center_product_wrap {
                flex: 1;
                background-color: #FFFFFF;
                padding: 16px;
                border-radius: 6px;

                .search_input {
                    width: 260px;
                }

                .el-table {
                    margin-top: 16px;
                    border-radius: 6px 6px 0 0;

                    .el-table__header {
                        tr th {
                            padding: 0;
                            height: 38px;
                            background-color: #EDF0F4;
                            border-color: rgba(0, 0, 0, 0.04);

                            &:first-child {
                                border-radius: 6px 0 0 0;
                            }

                            &:last-child {
                                border-radius: 0 6px 0 0;
                            }

                            .cell {
                                line-height: 22px;
                                font-weight: normal;
                                color: #333333;
                            }
                        }
                    }

                    tr td {
                        .cell {
                            line-height: 21px;
                            color: #666666;
                        }
                    }
                }

                .goods_name {
                    margin-right: 8px;
                }
            }

            .right_selected_wrap {
                width: 296px;
                background-color: #FFFFFF;
                border-radius: 6px;

                h4 {
                    padding: 16px;
                    line-height: 22px;
                    font-size: 14px;
                    color: #333333;
                }

                .selected_list {
                    width: 100%;
                    height: calc(100% - 105px);
                    overflow-y: auto;
                    padding: 0 8px;

                    .selected_item {
                        border-radius: 4px;
                        margin-bottom: 8px;
                        line-height: 22px;
                        padding: 4px 8px;
                        display: flex;
                        align-items: center;

                        .selected_name_wrap {
                            color: #666666;
                            flex: 1;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }

                        .handle_icon_wrap {
                            display: none;
                        }

                        &:hover {
                            background-color: rgba(0, 0, 0, 0.04);

                            .selected_name_wrap {
                                color: #333333;
                            }

                            .handle_icon_wrap {
                                display: block;
                            }
                        }
                    }
                }

                .handle_btn_wrap {
                    box-shadow: 0px -2px 4px -2px rgba(0, 0, 0, 0.08);
                    border-radius: 0 0 6px 6px;
                    padding: 10px 16px;
                    text-align: right;
                }
            }
        }
    }
}
</style>